import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import App, { Props } from './App';
import { AppState } from '../../types/store';
import { appLoaded } from '../../actions/app';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';

export type StateProps = Pick<Props, 'environment' | 'currentUser'>;
export type DispatchProps = Pick<Props, 'appLoaded'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => {
  return {
    environment: getEnv(state).type,
    currentUser: getCurrentUser(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  appLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
